//const
const USER_LIST_UPDATE_DATA = "userList/USER_LIST_UPDATE_DATA";

//reducer
export const userList = (state = {
  selectedUser: "",
}, action) => {
  switch (action.type) {
    case USER_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    default:
      return state
  }
};

export const updateData = (data) => {
  return {
    type: USER_LIST_UPDATE_DATA,
    data: data
  }
};
